export enum IdentityProvider {
  Google = 'google',
  Apple = 'apple',
  Microsoft = 'microsoft',
}
